module.exports = __webpack_public_path__ + "static/basement-62b7b438b4948e8ea98957d673d52838.jpg";